import type { ReactElement } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import _t from "@core/i18n"

type Props = {
  value: string
}

export default function LowestPriceInfo({
  value,
  ...restProps
}: Props): ReactElement<Props> | null {
  return (
    <TextAtm typography="nano1" emphasis="medium" {...restProps}>
      {_t("prices.lowerPriceText")} {value}
    </TextAtm>
  )
}
